import axios from 'axios';
import { ADMIN_LOGIN_PATH } from '../constants';
import { getStorage, removeStorage } from '../utils/storage';

const api = axios.create({
  baseURL: '/api',
});

// Публичные пути, на которых НЕ нужен редирект на скрытый вход при 401
// (страницы входа, реквизитов, оферты, согласия и публичного результата).
const PUBLIC_PATHS = [
  '/',
  '/login',
  ADMIN_LOGIN_PATH,
  '/requisites',
  '/privacy',
  '/offer',
  '/results-gates',
  '/result/',
  '/compare-entry',
  '/compare-result/',
];

const isPublicPath = (pathname: string): boolean =>
  PUBLIC_PATHS.some((p) => pathname === p || pathname.startsWith(p + '/'));

// Интерсептор запросов — добавляем токен
api.interceptors.request.use((config) => {
  const token = getStorage('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Интерсептор ответов — обрабатываем ошибки безопасно
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('Axios ошибка:', error.message);

    if (error.response) {
      if (error.response.status === 401) {
        removeStorage('token');
        // Редиректим на страницу входа администратора только для защищённых
        // путей. На публичных страницах 401 (например, /auth/me без токена)
        // не должен утаскивать пользователя со страницы.
        if (!isPublicPath(window.location.pathname)) {
          window.location.href = ADMIN_LOGIN_PATH;
        }
      }
    } else if (error.request) {
      console.error('Нет ответа от сервера. Возможно CORS или сеть.');
    } else {
      console.error('Ошибка настройки запроса:', error.message);
    }

    return Promise.reject(error);
  }
);

export default api;
